import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { FormsModule } from '@angular/forms';
import { MatTooltip, MatTooltipModule } from '@angular/material/tooltip';
import { NzAlertModule } from 'ng-zorro-antd/alert';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzPopconfirmModule } from 'ng-zorro-antd/popconfirm';
import { NzPopoverModule } from 'ng-zorro-antd/popover';
import { NzTableModule } from 'ng-zorro-antd/table';
import { NzTagModule } from 'ng-zorro-antd/tag';
import { take } from 'rxjs';
import { TruncatePipe } from '../../basic/pipes/truncate.pipe';
import { Tag } from '../../core/tag/tag';
import { TagService } from '../../core/tag/tag.service';
import { NewEditMethodologyComponent } from '../../domain/methodology/new-edit-methodology/new-edit-methodology.component';
import { NewEditTagComponent } from '../../domain/tag/new-edit-tag/new-edit-tag.component';
import { BasicPageComponent } from '../_shared/basic-page/basic-page.component';

@Component({
  selector: 'app-tags',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,

    NzInputModule,
    NzIconModule,
    NzButtonModule,
    NzTableModule,
    NzPopoverModule,
    NzModalModule,
    NzAlertModule,
    NzPopconfirmModule,
    NzTagModule,

    MatTooltipModule,

    TruncatePipe,

    MatTooltip,

    NewEditTagComponent,
    NewEditMethodologyComponent,
    BasicPageComponent,
  ],
  templateUrl: './tags.component.html',
  styleUrl: './tags.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TagsComponent {
  constructor(private tagService: TagService) {}

  isNewEditVisible = false;
  selectedParentTag?: Tag;
  selectedTag?: Tag;

  tagList = toSignal(this.tagService.tagList$(), { initialValue: [] });

  rootTagList = computed(() => {
    const tagList = this.tagList();
    return tagList.filter((tag) => tag.parentId === undefined);
  });

  getTagList(parentId?: string) {
    return this.tagList().filter((tag) => tag.parentId === parentId);
  }

  onNewBtnClick(rootTag?: Tag) {
    this.selectedParentTag = rootTag;
    this.isNewEditVisible = true;
  }

  onEditTagClick(tag: Tag) {
    this.selectedTag = tag;
    this.isNewEditVisible = true;
  }

  onDeleteClick(i: number) {
    this.tagService.deleteTagList$([this.tagList()[i]]).pipe(take(1)).subscribe();
  }

  onDeleteTagClick(tag: Tag) {}

  newEditTagVisibleChange(isVisible: boolean) {
    if (isVisible === false) {
      this.selectedTag = undefined;
      this.selectedParentTag = undefined;
    }
  }
}
